import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={30}
    height={30}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
     x={0.5} 
     y={0.5} 
     width={29} 
     height={29} 
     rx={5.5} 
     fill={props.bgcolor}
     stroke="#947550" />
    <path
      d="M13.0013 14.3407L13.2541 14.2059L13.7766 15.2509L14.67 13.9361L12.917 11.2896L10.2369 7.19354C10.1188 7.00811 9.84923 6.94074 9.66381 7.05867C9.09072 7.39577 8.85474 8.08691 9.09072 8.69373L11.0291 13.6495C11.3157 14.4417 12.2596 14.762 13.0013 14.3406L13.0013 14.3407Z"
      fill={props.color}
    />
    <path
      d="M16.2711 16.3638L15.3102 18.336L17.2992 22.3478C17.6025 22.9546 18.3442 23.1906 18.9342 22.8535L19.0353 22.7861C19.6254 22.449 19.8108 21.6736 19.423 21.1173L16.2711 16.3638Z"
      fill={props.color}
    />
    <path
      d="M20.8897 8.4409C20.7211 8.28922 20.4683 8.33978 20.3502 8.5252C20.3502 8.5252 18.8332 11.0368 18.3949 11.7448C18.3275 11.8459 18.1926 11.8796 18.0915 11.8291C17.9904 11.7617 17.9398 11.6268 18.0072 11.5257C18.4118 10.784 19.8109 8.22187 19.8109 8.22187C19.912 8.03645 19.8277 7.80046 19.6087 7.71615C19.457 7.66559 19.2884 7.73297 19.2041 7.86783L17.2487 11.0874C17.1813 11.1885 17.0465 11.2223 16.9454 11.1717C16.8442 11.1043 16.7937 10.9695 16.8611 10.8683C17.2656 10.1266 18.6647 7.5645 18.6647 7.5645C18.7659 7.37908 18.6816 7.1431 18.4625 7.05878C18.3108 7.00822 18.1422 7.0756 18.0579 7.21046L15.9846 10.6154L15.7318 11.0706C15.4621 11.5257 15.3778 12.0651 15.4958 12.4865L15.7486 13.3967L10.54 21.1C10.1692 21.6731 10.3378 22.4316 10.9277 22.7688L11.0288 22.8362C11.6189 23.1733 12.3774 22.9542 12.6639 22.3305L16.7263 13.9697L17.6364 13.7338C18.0747 13.6157 18.4793 13.2786 18.749 12.8236L19.0018 12.3684L20.9066 8.87916C21.0413 8.72748 21.0245 8.54207 20.8896 8.44093L20.8897 8.4409Z"
      fill={props.color}
    />
  </svg>
);
export default SVGComponent;
